import React from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { MY_UNREAD_NOTIFICATIONS_QUERY } from '../graphql/queries';

// Unread count for the signed-in user (never a managed family's), refreshed every minute
export default function NotificationBell({ color = 'inherit' }) {
  const navigate = useNavigate();
  const { data } = useQuery(MY_UNREAD_NOTIFICATIONS_QUERY, { pollInterval: 60000, fetchPolicy: 'cache-and-network' });
  const unread = data?.myNotifications?.length || 0;
  return (
    <Tooltip title={unread ? `${unread} unread notification${unread === 1 ? '' : 's'}` : 'Notifications'}>
      <IconButton color={color} size="small" onClick={() => navigate('/dashboard/notifications')}>
        <Badge badgeContent={unread} color="error" max={99}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
